import type { RefObject } from "react";

import { swSettings } from "app/common/services/swSettings";
import { translate } from "app/filters/i18nFilter";
import { PdfExportService } from "app/services/PdfExportService";
import { allTrackers } from "app/services/track/track";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export const isPeriodOverPeriod = () => {
    return !!proNavigator.getParams().comparedDuration;
};

export const updateUrlParam = (granularity) => {
    // without settimeout $digest already in progress error occurs
    setTimeout(() => proNavigator.updateParams({ channelAnalysisGranularity: granularity.value }), 0);
};
export const handleChannelFilterChange = (value) => {
    proNavigator.updateParams({ channelAnalysisChannel: value });
};
export const handleMetricChange = (index) => {
    proNavigator.updateParams({ channelAnalysisMetric: index });
};

export const getLastWindowDate = () => {
    return swSettings.current.lastSupportedDailyDate;
};

export const getDateRange = (durationObject, isMTDActive) => {
    if (!isMTDActive) {
        return [durationObject.raw.from, durationObject.raw.to];
    }
    return [durationObject.raw.from, getLastWindowDate()];
};

export const getCompareDateRange = (durationObject) => [durationObject.raw.compareFrom, durationObject.raw.compareTo];

export const getPNG = (chartRef: RefObject<HTMLElement>): Promise<void> => {
    allTrackers.trackEvent("Download", "submit-ok", "Bar Chart/Traffic Sources Overview/PNG");
    const styleHTML = PdfExportService.getStylesheetsForPng();
    const offSetX = 0;
    const offSetY = 50;
    return PdfExportService.downloadHtmlPngFedService(
        styleHTML + chartRef.current.outerHTML,
        translate("mmx.trafficSources.bar.title"),
        chartRef.current.offsetWidth + offSetX,
        chartRef.current.offsetHeight + offSetY,
    );
};
